import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

const Page = ({ data }) => (
  <Layout>
    <SEO title="Datenschutz" />
    <div dangerouslySetInnerHTML={{ __html: data.wordpressPage.content }}></div>
  </Layout>
)

export const query = graphql`
  query {
    wordpressPage(id: { eq: "359c1723-01c3-59cf-be97-540296d0d494" }) {
      content
    }
  }
`

export default Page
